import React from 'react'

import Metric, { useMetric } from './Metric/Metric'
import AreaChart from './Charts/AreaChart'

import { METRIC_GRAPTH } from './constants'

const IncludeCoverageWidget = () => {
  const { data, loading, subTitle, queryType, queryId, refreshGraph, warningMessage } = useMetric(
    METRIC_GRAPTH.INCLUDE_COVERAGE
  )

  return (
    <Metric loading={loading} warningMessage={warningMessage}>
      <Metric.Header title="Revenue Covered by Include Query" disabled={!queryId} refreshGraph={refreshGraph} />
      <Metric.Query key={queryId} queryType={queryType} />
      <AreaChart
        data={data}
        subTitle={subTitle}
        yAxisTitle="Revenue Within Category (%)"
        threshold={30}
        isInvertQuery
        isPercentBetweenSeries
      />
    </Metric>
  )
}

export default React.memo(IncludeCoverageWidget)
